// repo/primary-care-connect/frontend/src/pages/Portal/CommunityNavigator/CaseDetail/components/PatientDetailsCard.tsx

import type { NavigatorCaseDetail } from "../types";
import {
  formatDateOnly,
  formatDateTime,
  formatPatientName,
  formatSource,
  getContactStatus,
  getDerivedAgeGroup,
  getPatientAge,
  getPrimaryEmail,
  getPrimaryPhone,
} from "../intakeUtils";
import DetailItem from "./DetailItem";

type PatientDetailsCardProps = {
  caseDetail: NavigatorCaseDetail;
  assignmentLabel: string;
  canEditPatientDetails?: boolean;
  onUpdatePatientDetails?: () => void;
};

export default function PatientDetailsCard({
  caseDetail,
  assignmentLabel,
  canEditPatientDetails = false,
  onUpdatePatientDetails,
}: PatientDetailsCardProps) {
  return (
    <section className="cn-case-detail-card cn-case-detail-patient-card">
      <div className="cn-case-detail-card-header">
        <div>
          <h2>Patient details</h2>
        </div>

        {onUpdatePatientDetails ? (
          <button
            type="button"
            className="cn-case-detail-secondary-button"
            onClick={onUpdatePatientDetails}
            disabled={!canEditPatientDetails}
          >
            Update patient details
          </button>
        ) : null}
      </div>

      <dl className="cn-case-detail-list cn-case-detail-list-two">
        <DetailItem label="Name" value={formatPatientName(caseDetail)} />
        <DetailItem
          label="Date of birth"
          value={formatDateOnly(caseDetail.patient.dateOfBirth)}
        />
        <DetailItem
          label="Age"
          value={getPatientAge(caseDetail.patient.dateOfBirth)}
        />
        <DetailItem
          label="Derived age group"
          value={getDerivedAgeGroup(caseDetail.patient.dateOfBirth)}
        />
        <DetailItem
          label="Gender"
          value={caseDetail.patient.gender || caseDetail.gender || "—"}
        />
        <DetailItem
          label="Postal code"
          value={caseDetail.patient.postalCode || "—"}
        />
        <DetailItem label="FSA" value={caseDetail.patientFsa || "—"} />
        <DetailItem label="Phone" value={getPrimaryPhone(caseDetail)} />
        <DetailItem label="Email" value={getPrimaryEmail(caseDetail)} />
        <DetailItem
          label="Contact status"
          value={getContactStatus(caseDetail)}
        />
        <DetailItem label="City" value={caseDetail.patientCityName || "—"} />
        <DetailItem
          label="Assigned to"
          value={assignmentLabel}
        />
        <DetailItem
          label="Source"
          value={formatSource(caseDetail.sourceType)}
        />
        <DetailItem
          label="Source label"
          value={caseDetail.sourceLabel || "—"}
        />
        <DetailItem
          label="Case number"
          value={`#${caseDetail.navigatorCaseId}`}
        />
        <DetailItem
          label="Created"
          value={formatDateTime(caseDetail.createdAt)}
        />
      </dl>
    </section>
  );
}